module.exports = __webpack_public_path__ + "static/img/ios.a85a0d39.png";